import React, { useState } from 'react';
import Header from '../components/Header';
import LeadModal from '../components/LeadModal';
import './Cases.css';

const CASES = [
  {
    id: 1,
    title: 'Комплексная поставка электротехнического оборудования для охраны береговой линии',
    customer: 'Пограничная служба ФСБ России',
    object: 'Охрана береговой линии (место не раскрывается в связи с NDA)',
    task: 'Комплексная поставка шкафов и комплектующих для систем охраны в сложных климатических условиях.',
    solution: 'Мы осуществили комплексную поставку электротехнических шкафов (включая корпуса из нержавеющей стали AISI 304) и комплектующих для систем охраны береговой линии. Оборудование работает в условиях морской воды, высокой влажности и перепадов температур.',
    result: 'Оборудование успешно эксплуатируется, выдерживает агрессивную морскую среду. Проект реализован с соблюдением всех требований режима секретности.',
    photo: null,
    photoCaption: 'Фотоотчёт не предоставляется в соответствии с условиями NDA',
  },
  {
    id: 2,
    title: 'Модернизация гальванического производства',
    customer: 'Промышленное предприятие, г. Санкт-Петербург',
    object: 'Гальванический цех',
    task: 'Поставка взрывозащищённых шкафов для эксплуатации в агрессивной среде с химическими парами и повышенной влажностью.',
    solution: 'Мы изготовили и поставили взрывозащищённые шкафы серии Ex d/Ex e. Оборудование рассчитано на работу в условиях агрессивных химических сред и взрывоопасных зон. Степень защиты — IP66, что обеспечивает полную герметичность и защиту от пыли и влаги.',
    result: 'Оборудование успешно прошло испытания и введено в эксплуатацию. Шкафы обеспечивают безопасную работу производственного оборудования в условиях гальванического цеха.',
    photo: '/images/case-cabinets.webp',
    photoCaption: 'Иллюстрация: шкафы нашего производства, аналогичные поставленным по проекту',
  },
];

const Cases = () => {
  const [isLeadModalOpen, setIsLeadModalOpen] = useState(false);

  return (
    <>
      <Header />
      <section className="cases-hero">
        <div className="container-custom">
          <h1 className="cases-hero-title">Наши проекты</h1>
          <p className="cases-hero-lead">
            Мы выполняем поставки для объектов повышенной ответственности: АЭС, судостроение, нефтегаз,
            спецпроекты. Ниже — примеры реализованных задач.
          </p>
        </div>
      </section>

      <section className="cases-section">
        <div className="container-custom">
          <div className="cases-list">
            {CASES.map((item) => (
              <article key={item.id} className="case-card">
                <div className="case-card-media">
                  {item.photo ? (
                    <img src={item.photo} alt={item.title} />
                  ) : (
                    <div className="case-card-placeholder">
                      <span>Фото по запросу</span>
                    </div>
                  )}
                  {item.photoCaption && <p className="case-card-photo-caption">{item.photoCaption}</p>}
                </div>
                <div className="case-card-body">
                  <h2 className="case-card-title">{item.title}</h2>
                  <dl className="case-card-meta">
                    <div>
                      <dt>Заказчик</dt>
                      <dd>{item.customer}</dd>
                    </div>
                    <div>
                      <dt>Объект</dt>
                      <dd>{item.object}</dd>
                    </div>
                  </dl>
                  <div className="case-card-block">
                    <h3>Задача</h3>
                    <p>{item.task}</p>
                  </div>
                  <div className="case-card-block">
                    <h3>Решение</h3>
                    <p>{item.solution}</p>
                  </div>
                  <div className="case-card-block">
                    <h3>Результат</h3>
                    <p>{item.result}</p>
                  </div>
                </div>
              </article>
            ))}
          </div>

          <div className="cases-cta">
            <button type="button" className="cases-cta-btn" onClick={() => setIsLeadModalOpen(true)}>
              Обсудить ваш проект
            </button>
          </div>
        </div>
      </section>

      <LeadModal show={isLeadModalOpen} onClose={() => setIsLeadModalOpen(false)} goalId="form-menu" />
    </>
  );
};

export default Cases;
